/**
 * dt-spinner - Loading indicator with size variants
 * Sizes: small (16px), medium (24px), large (48px)
 */
import { BaseElement } from '../base-element';

export class DtSpinner extends BaseElement {
  static observedAttributes = ['size'];

  private _size: 'small' | 'medium' | 'large' = 'medium';

  get size(): string {
    return this._size;
  }

  set size(value: string) {
    if (['small', 'medium', 'large'].includes(value)) {
      this._size = value as 'small' | 'medium' | 'large';
      this.updateRender();
    }
  }

  connectedCallback(): void {
    this.updateRender();
  }

  attributeChangedCallback(name: string, _oldValue: string, newValue: string): void {
    if (name === 'size') {
      this.size = newValue || 'medium';
    }
  }

  private getSizeClasses(): { dimension: string; pixels: string } {
    switch (this._size) {
      case 'small':
        return { dimension: 'h-4 w-4', pixels: '16px' };
      case 'large':
        return { dimension: 'h-12 w-12', pixels: '48px' };
      default:
        return { dimension: 'h-6 w-6', pixels: '24px' };
    }
  }

  private updateRender(): void {
    const { dimension, pixels } = this.getSizeClasses();

    this.render(`
      <svg 
        class="animate-spin text-primary-500 ${dimension}" 
        fill="none" 
        viewBox="0 0 24 24"
        role="status"
        aria-label="Loading"
        data-size="${pixels}"
      >
        <circle 
          class="opacity-25" 
          cx="12" 
          cy="12" 
          r="10" 
          stroke="currentColor" 
          stroke-width="4"
        ></circle>
        <path 
          class="opacity-75" 
          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" 
          fill="currentColor"
        ></path>
      </svg>
    `);
  }
}

customElements.define('dt-spinner', DtSpinner);
